import styled, { css } from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { Autocomplete } from "@similarweb/ui-components";

export const StyledListItem = styled.div`
    padding: 14px 16px;
    ${setFontVariant("input2", colorsPalettes.carbon[500])};
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    position: relative;
    background-color: ${colorsPalettes.carbon[0]};
    overflow: hidden;
    white-space: nowrap;
    &:hover {
        background-color: ${colorsPalettes.bluegrey[200]};
    }
`;

export const StyledListItemText = styled.div`
    max-width: 185px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
`;

export const StyledItemsContainer = styled.div`
    max-height: 333px;
    overflow-y: auto;
`;

export const StyledAutocomplete = styled(Autocomplete)<{ isFocused: boolean }>`
    width: 100%;

    ${({ isFocused }) =>
        isFocused
            ? css`
                  & ${SWReactIcons}[data-automation-icon-name="search"] {
                      margin-top: 4px;
                      width: 24px;
                      height: 24px;
                      margin-right: 8px;
                  }
              `
            : css`
                  & ${SWReactIcons}[data-automation-icon-name="search"] {
                      display: none;
                  }
              `}
`;
